import type { PrintJobConfig } from '@/types/index';
import type { PaperSize, PrintOrientation } from '@/types/printRequest.types';

const PAPER_SIZE_MAP: Record<string, PaperSize> = {
  a4: 'A4',
  letter: 'Letter',
  legal: 'Legal',
};

/**
 * The backend's paper_size enum only supports A4 / Letter / Legal — there is
 * no A3. Falls back to A4 with a console warning if a3 is ever selected;
 * either add A3 support on the backend or remove it from PAPER_SIZES in
 * constants/printOptions.ts until it does.
 */
export function toBackendPaperSize(paperSizeId: PrintJobConfig['paperSizeId']): PaperSize {
  const mapped = PAPER_SIZE_MAP[paperSizeId];
  if (mapped) return mapped;
  // eslint-disable-next-line no-console
  console.warn(`paper_size "${paperSizeId}" is not supported by the backend yet — falling back to A4.`);
  return 'A4';
}

export function toBackendOrientation(orientation: PrintJobConfig['orientation']): PrintOrientation {
  return orientation === 'landscape' ? 'LANDSCAPE' : 'PORTRAIT';
}

/** Backend takes one page-range string; empty string means "all pages". */
export function toBackendPageRange(config: PrintJobConfig): string {
  if (config.rangeMode === 'all') return '';
  return config.rangeExpression || `${config.fromPage}-${config.toPage}`;
}